/**
 * Deep links into the SPA, shared by the API (notification emails) and the
 * SPA itself (the task card's Copy link button).
 *
 * One definition on purpose: the link in an assignment email and the link a
 * teammate copies out of the UI must be the same link, and they are built on
 * opposite sides of the wire.
 */

/**
 * Path to a single task. The Tasks screen reads `?task=` on mount and opens
 * that task's detail card, so the link lands on the work itself rather than on
 * a list the reader has to search.
 */
export function taskPath(taskId: string): string {
  return `/tasks?task=${encodeURIComponent(taskId)}`
}

/** Absolute task URL for a given app origin (trailing slash tolerated). */
export function taskUrl(origin: string, taskId: string): string {
  return `${origin.replace(/\/$/, '')}${taskPath(taskId)}`
}
